module.exports = __webpack_public_path__ + "img/cavin-lp.56054439.png";